import { createContext, useContext, useState, useCallback, useMemo } from "react";
import { translations, detectLang } from "@/i18n";

const LangContext = createContext(null);

export function LangProvider({ children }) {
  const [lang, setLangState] = useState(detectLang());

  const setLang = useCallback((l) => {
    localStorage.setItem("studio_sync_lang", l);
    setLangState(l);
  }, []);

  const toggle = useCallback(() => setLang(lang === "en" ? "es" : "en"), [lang, setLang]);

  const t = useCallback(
    (key) => (translations[lang] && translations[lang][key]) || key,
    [lang]
  );

  const value = useMemo(() => ({ lang, setLang, toggle, t }), [lang, setLang, toggle, t]);
  return <LangContext.Provider value={value}>{children}</LangContext.Provider>;
}

export const useLang = () => useContext(LangContext);
